// src/js/core/topics.js
export const TOPICS = [
  //they are...
  // Basic
  "planning a vacation",
  "discussing a new restaurant",
  "sharing weekend plans",
  "talking about a recent movie",
  "discussing career changes",
  "sharing family news",
  "planning a party",
  "discussing a new hobby",
  "talking about the weather",
  "sharing book recommendations",
  "discussing local events",
  "planning a dinner",
  // Current events
  "planning for spring break",
  // Technology & Future
  "debating whether AI will help or harm humanity",
  "planning to live on Mars",
  "discussing a world without smartphones",
  "imagining future transportation",
  "discussing learning with AI",
  // Hypotheticals & Adventure
  "what to do after winning the lottery",
  "planning a secret mission",
  "discovering a magical ability",
  "exploring an ancient temple",
  "stuck on a a deserted island, planning how to survive",
  "choosing a superpower",
  // Personal Growth & Dreams
  "starting a million-dollar business",
  "living in a different century",
  "switching lives with someone famous",
  // Mysteries & Excitement
  "solving a mysterious disappearance",
  "finding a mysterious object",
  "encountering aliens",
  "discovering a parallel universe",
  // Fun & Creative
  "training pets",
  "designing the perfect city",
  "discussing music",
  "discussing classic cars",
  "discussing the 90s",
  "discussing the 80s",
  // Health
  "discussing new exercise research findings",
  "both feeling sick",
  // Business
  "planning a marketing campaign",
  "discussing marketing strategies for a new product",
  "designing a new product",
  "running a restaurant",
];

export function getRandomTopic() {
  const randomIndex = Math.floor(Math.random() * TOPICS.length);
  return TOPICS[randomIndex];
}
